// extracted by mini-css-extract-plugin
module.exports = {"container":"CardRegisterForm_container__HU3fA","inner":"CardRegisterForm_inner__9_odq","btn-save":"CardRegisterForm_btn-save__MYyfX"};